<template>
  <div>
    <div class>
      <a-form :form="form" @submit="handleSubmit">
         <div
            :style="{ borderBottom: '1px solid #E9E9E9',marginBottom:'10px',paddingBottom:'10px' }"
          >
        <a-checkbox
        :checked="checkAll"
                @change="onCheckAll(!checkAll)"
              >全选</a-checkbox>
         </div>
        <div v-for="(permiss,index) in permissionList" :key="index">
          <div
            :style="{ borderBottom: '1px solid #E9E9E9',marginBottom:'10px',paddingBottom:'10px' }"
          >
            <div :style="{ fontWeight:'bold',marginBottom:'5px' }">
              <a-checkbox
                @change="onCheckAllChange(!permiss.isChecked,index)"
                :checked="permiss.isChecked"
              >{{permiss.type}}</a-checkbox>
            </div>
            <a-checkbox-group
              :options="permiss.value"
              v-model="checkedList[index]"
              @change="onCheckChildChange(index)"
            />
          </div>
        </div>

        <a-form-item :wrapper-col="{ span:24, offset: 10 }">
          <pxkeji-btn name="确认" type="primary" htmlType="submit"/>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
var that;
export default {
  props: {
    id: Number,
    checkAuth: Array
  },
  data() {
    return {
      isloading:false,
      form: this.$form.createForm(this),
      dis: this.disabled,
      permissionList: [],
      checkedList: [],
      roleOptions: [],
      checkAll:false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      that = this;
      this.getInfo();
      //this.checkedList = this.checkAuth;
    });
  },
  methods: {
    sumbit() {
      this.$emit("callbackMethod");
    },
    onapplyChange(e) {
      // console.log("radio checked", e.target.value);
    },
    getInfo() {
      that.isloading = true;
      that.$api.role
        .getAllClaims()
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.permissionList = res.data;
            for (var i = 0; i < that.permissionList.length; i++) {
              that.permissionList[i].isChecked = false;
              that.checkedList[i]=[];
              //数据回显对勾
              var  num= 0;
              for (var a = 0; a < that.permissionList[i].value.length; a++) {
              
                var cinfo = that.permissionList[i].value[a];
                var v=that.permissionList[i].type+"-"+cinfo;
                var s=that.selRole(v, that.checkAuth);
                if (s) {
                  that.checkedList[i].push(cinfo);
                  num++;
                }
                
              }
             
              if (num == that.checkedList[i].length) {
                  that.permissionList[i].isChecked = true;
              }
            }

            that.refreshCheckAllStatus();
            
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    refreshCheckAllStatus(){
        var count=0;
        that.permissionList.forEach(function(item,index){
          if(item.isChecked){
            count+= 1;
          }
        })
        this.checkAll=count==that.permissionList.length;
    },
    onCheckAll(val){
      this.checkAll=val;
      var index =0;
      var i=0;
      if (val) {
        for (index = 0; index < this.permissionList.length; index++) {
           this.permissionList[index].isChecked = true;
          for (i = 0; i < this.permissionList[index].value.length; i++) {
            var info = this.permissionList[index].value[i];
            if (this.checkedList[index].indexOf(info) == -1) {
              this.checkedList[index].push(info);
            }
          }
        }
       
      } else {
        for (index = 0; index < this.permissionList.length; index++) {
          this.permissionList[index].isChecked = false;
          for (var i = 0; i < this.permissionList[index].value.length; i++) {
            var info = this.permissionList[index].value[i];
            if (this.checkedList[index].indexOf(info) > -1) {
              this.checkedList[index].splice(this.checkedList[index].indexOf(info), 1);
            }
          }
        }
      }
    },
    /**全选 */
    onCheckAllChange(val, index) {
      var info = this.permissionList[index];
      if (val) {
        info.isChecked = true;
        for (var i = 0; i < this.permissionList[index].value.length; i++) {
          var info = this.permissionList[index].value[i];
          if (this.checkedList[index].indexOf(info) == -1) {
            this.checkedList[index].push(info);
          }
        }
      } else {
        info.isChecked = false;
        for (var i = 0; i < this.permissionList[index].value.length; i++) {
          var info = this.permissionList[index].value[i];
          if (this.checkedList[index].indexOf(info) > -1) {
            this.checkedList[index].splice(this.checkedList[index].indexOf(info), 1);
          }
        }
      }
      this.refreshCheckAllStatus();
    },
    /**子集 */
    onCheckChildChange(index) {
      var info = this.permissionList[index];
      info.isChecked = this.checkedList[index].length==this.permissionList[index].value.length;
      this.refreshCheckAllStatus();
    },
    selRole(s, data) {
      var isPass = false;
      for (var j = 0; j < data.length; j++) {
        if (s == data[j]) {
          isPass = true;
          break;
        }
      }
      return isPass;
    },
    handleSubmit(e) {
      e.preventDefault();
       var result=[];
        for (var i = 0; i < this.permissionList.length; i++) {
          var type = this.permissionList[i].type;
          for(var j=0;j<this.checkedList[i].length;++j){
            result.push(type+"-"+this.checkedList[i][j]);
          }
          
        }
        
        console.log(result);
      if (result.length == 0) {
        that.$message.error("请选择权限!");
        return;
      } else {
        this.$emit("callbackMethod", result);
      }
    }
  }
};
</script>
<style>
.setBtn {
  cursor: pointer;
  color: #1890ff;
}
</style>